module.exports = __webpack_public_path__ + "img/ambulance-01.3284460b.png";